import http from 'utils/http';
import {
  getAvailableIntegrationsUrl,
  getCalendersUrl,
  getIntegrationsUrl,
  getIntegrationUrl,
  getNewIntegrationsUrl,
  getOauthRedirectUrl
} from './apiUrls';
import { AvailableIntegrationResponse, IntegrationResponse } from './types';
import { MetaApiResponse } from 'utils/types/CommonApiResponse';

export function getAvailableIntegrations(
  workspaceId: string,
  params?: Record<string, any>
): Promise<{ data: AvailableIntegrationResponse[]; meta: MetaApiResponse }> {
  return http.get(getAvailableIntegrationsUrl(workspaceId), params);
}

export function getNewIntegrationsFields(code: string, workspaceId: string): Promise<any> {
  return http.get(getNewIntegrationsUrl(workspaceId), { code });
}

export function getIntegrations(
  workspaceId: string,
  params?: Record<string, any>
): Promise<{ data: IntegrationResponse[]; meta: MetaApiResponse }> {
  return http.get(getIntegrationsUrl(workspaceId), params);
}

export function createIntegrations(workspaceId: string, payload: any): Promise<any> {
  return http.post(getIntegrationsUrl(workspaceId), payload);
}

export function createOauthIntegrations(code: string, payload: any): Promise<any> {
  return http.post(getOauthRedirectUrl(code), payload);
}

export function getCalenders(workspaceId: string, id: number): Promise<{ value: number; label: string }[]> {
  return http.get(getCalendersUrl(workspaceId, id));
}

export function deleteIntegration(workspaceId: string, id: number): Promise<{ meta: { message: string } }> {
  return http.delete(getIntegrationUrl(workspaceId, id));
}
